import React, { useState, useEffect, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Form, Row, Col, message, Select, Spin } from 'antd';
import PropTypes from 'prop-types';
import { AddUser } from '../style';
import { FetchAllApprovalMyList, OutreachLeadUpdate } from '../../../Api/Services/SequenceApiService';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { EmailseqQueueIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

// pageFrom: "modal" (default, listing page) | "inline" (query page)
const Popup = ({ sharePopup, setSharePopup, sharingIds, PageTypes, setStates, selectedRows, onSuccess, pageFrom, PreviousButton }) => {
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [exportData, setExportData] = useState([])
    const [display, setDisplay] = useState(false)
    const [uiReady, setUiReady] = useState(false)

    async function getAllOutreach() {
        try {
            const response = await FetchAllApprovalMyList()
            const SortedData = response.sort((a, b) => b.outreachId - a.outreachId)
            if (PageTypes === "Single") {
                const filteredData = SortedData.filter(outreach =>
                    !outreach.leads?.some(lead => lead.leadId === Number(sharingIds))
                )
                setExportData(filteredData)
            } else {
                setExportData(SortedData)
            }
        } catch (err) {
            setExportData([])
            message.error(err);
        }
    }

    const handleClose = () => {
        setSharePopup(false);
        if (PageTypes === "Multiple") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
    }

    // Core submit logic - shared between modal and inline modes
    const doSubmit = async (outreachName, rows) => {
        const outreachData = exportData.find(item => item.outreachId === outreachName);
        if (!outreachData) return;

        const outreachLeadIds = outreachData.leads?.map(l => l.leadId) || [];
        const alreadyPresentLeads = rows.filter(row => outreachLeadIds.includes(row.key));
        const newLeadIds = rows
            .filter(row => !outreachLeadIds.includes(row.key))
            .map(row => row.key);
        const proceed = async () => {
            let hideMessage;
            try {
                hideMessage = message.loading("Loading...", 0);
                if (newLeadIds.length > 0) {
                    const leadIds = newLeadIds.join(",");
                    await OutreachLeadUpdate({}, outreachName, leadIds);
                }
                hideMessage();
                setDisplay(false)
                loadingRef.current = false;
                setDelteClick(false)
                message.success(`Selected leads have been successfully added to the outreach assistant`)
                if (pageFrom === "inline") {
                    if (onSuccess) onSuccess();
                } else {
                    setSharePopup(false);
                    if (PageTypes === "Multiple") {
                        setStates({ selectedRows: [], selectedRowKeys: [] })
                    }
                }
            } catch (err) {
                loadingRef.current = false;
                setDelteClick(false)
                if (hideMessage) hideMessage();
                setDisplay(false)
                message.error("Failed to add leads to the outreach assistant");
            }
        };

        const confirmContent = alreadyPresentLeads.length > 0 ? (
            <div>
                {newLeadIds.length > 0 ? "The following lead(s) are already in this outreach sequence and will be skipped:" : "The following leads are already part of this outreach Assistant:"}
                <ul>
                    {alreadyPresentLeads.map(lead => (
                        <li key={lead.key}>
                            • {lead.LeadDataForPermission?.first_name} {lead.LeadDataForPermission?.last_name}
                        </li>
                    ))}
                </ul>
                {newLeadIds.length > 0 ? "New lead(s) will be added to the sequence and may receive an automated email.Do you want to continue?" : ""}
            </div>
        ) : (
            <div>Adding this lead(s) to the outreach sequence may trigger an automated email to the lead. Do you want to continue?</div>
        );

        Modal.confirm({
            icon: null,
            className: "customice-confirm-modal",
            title: (
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: "#f28e42", fontSize: 20 }} />
                    <span>{alreadyPresentLeads.length > 0 ? "Duplicate Leads Found" : "Confirm Action"}</span>
                </div>
            ),
            content: confirmContent,
            centered: true,
            okText: "Yes",
            cancelText: "Cancel",
            okButtonProps: {
                className: "button_colorsModal",
                style: { display: newLeadIds.length > 0 ? "inline-block" : "none" }
            },
            cancelButtonProps: { className: "gray-buttonModal" },
            async onOk() { await proceed(); },
            onCancel() {
                loadingRef.current = false;
                setDelteClick(false)
                setDisplay(false)
            },
        });
    }

    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        setDisplay(true)

        const { outreachName } = values;

        if (PageTypes === "Single") {
            let hideMessage;
            Modal.confirm({
                icon: null,
                className: "customice-confirm-modal",
                title: (
                    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                        <ExclamationCircleOutlined style={{ color: "#f28e42", fontSize: 20 }} />
                        <span>Confirm Action</span>
                    </div>
                ),
                content: <div>Adding this lead to the outreach sequence may trigger an automated email to the lead. Do you want to continue?</div>,
                centered: true,
                okText: "Yes",
                cancelText: "Cancel",
                okButtonProps: { className: "button_colorsModal" },
                cancelButtonProps: { className: "gray-buttonModal" },
                async onOk() {
                    try {
                        hideMessage = message.loading("Loading...", 0);
                        const response = await OutreachLeadUpdate({}, outreachName, sharingIds)
                        if (response.status === 200) {
                            message.success(`Selected lead have been successfully added to the outreach sequence`)
                            hideMessage();
                            setDisplay(false)
                            setSharePopup(false);
                            if (PageTypes === "Multiple") {
                                setStates({ selectedRows: [], selectedRowKeys: [] })
                            }
                            loadingRef.current = false;
                            setDelteClick(false)
                        }
                    } catch (error) {
                        loadingRef.current = false;
                        setDelteClick(false)
                        if (hideMessage) hideMessage();
                        setDisplay(false)
                        message.error(error)
                    }
                },
                onCancel() {
                    loadingRef.current = false;
                    setDelteClick(false)
                    setDisplay(false)
                },
            });
        } else {
            await doSubmit(outreachName, selectedRows || []);
        }
    }

    const fetchAll = async () => {
        await Promise.allSettled([getAllOutreach()])
        setUiReady(true)
    };

    useEffect(() => {
        fetchAll()
    }, [])

    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }

    const outreachSelect = (
        <Select
            style={{ width: '100%' }}
            placeholder="Select Outreach Assistant"
            showSearch
            optionLabelProp="label"
            optionFilterProp="children"
            filterOption={(input, option) => {
                const usernameElement = option.children.props.children[1].props.children[0];
                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                    return String(usernameElement.props.children).toLowerCase().includes(input.toLowerCase());
                }
                return false;
            }}
        >
            {exportData.map((option) => (
                <Option value={option.outreachId} key={option.outreachId} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={option.outreachName} style={{ cursor: "default" }}>
                                <span className="image_icon">{option.outreachName.slice(0, 1).toUpperCase()}</span>
                                <span className='div-ellipsis'>{option.outreachName}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={option.outreachName}>
                        <div>
                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                {option.outreachName.slice(0, 1).toUpperCase()}
                            </span>
                        </div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.outreachName}</p>
                        </div>
                    </div>
                </Option>
            ))}
        </Select>
    );

    // Inline mode - rendered inside LeadQueryPage "Perform Action" step
    if (pageFrom === "inline") {
        return (
            <AddUser style={{ width: "100%" }}>
                <div className="user-info-form">
                    <BasicFormWrapper>
                        {uiReady ? (
                            <Form style={{ width: '100%' }} form={form} name="OutreachInline" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <div style={{ textAlign: "center", fontSize: "larger", fontWeight: "700" }}>Add to Outreach Sequence</div>
                                <Row gutter={30} style={{ marginBottom: 20, marginTop: 20 }}>
                                    <Col span={4} />
                                    <Col span={16}>
                                        <Form.Item name="outreachName" rules={[{ required: true, message: 'Please select an outreach assistant' }]}>
                                            {outreachSelect}
                                        </Form.Item>
                                    </Col>
                                    <Col span={4} />
                                </Row>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "50px 25px 0px" }}>
                                    <Button size="small" className="gray-button" onClick={() => PreviousButton()}>
                                        <FeatherIcon icon="arrow-left" size={16} />Previous
                                    </Button>
                                    <Button htmlType="submit" className='btn-add_new button_colors' loading={deleteClick} disabled={deleteClick}>
                                        {!deleteClick && <EmailseqQueueIcon />}Add to Outreach
                                    </Button>
                                </div>
                            </Form>
                        ) : (
                            <div style={{ height: "300px" }} className="spin"><Spin /></div>
                        )}
                    </BasicFormWrapper>
                </div>
            </AddUser>
        );
    }

    // Modal mode - used from listing pages
    return (
        <>
            <Modal
                title="Add to Outreach Sequence"
                open={sharePopup}
                width={600}
                onCancel={handleClose}
                maskClosable={false}
                footer={uiReady ? [
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        <Button htmlType="submit" className="gray-button" size="small" onClick={handleClose} disabled={display}>
                            <FeatherIcon icon="x" /> Cancel
                        </Button>
                        <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={deleteClick} disabled={deleteClick}>
                            {!deleteClick && <EmailseqQueueIcon />} Add
                        </Button>
                    </div>
                ] : false}
            >
                {uiReady ? (
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="OutreachModal" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                    <Row gutter={30} style={{ padding: "0px 20px" }}>
                                        <Col span={24} style={{ margin: "10px 0px" }}>
                                            <Form.Item name="outreachName" id="outreachName" rules={[{ required: true, message: 'Please Select Outreach Assistant' }]}>
                                                {outreachSelect}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser>
                ) : (
                    <div style={{ height: "500px" }} className="spin"><Spin /></div>
                )}
            </Modal>
        </>
    );
};

Popup.propTypes = {
    sharePopup: PropTypes.bool,
    setSharePopup: PropTypes.func,
    sharingIds: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    PageTypes: PropTypes.string,
    setStates: PropTypes.func,
    selectedRows: PropTypes.array,
    onSuccess: PropTypes.func,
    pageFrom: PropTypes.string,       // "modal" (default) | "inline"
    PreviousButton: PropTypes.func,   // required when pageFrom="inline"
};

Popup.defaultProps = {
    pageFrom: "modal",
    selectedRows: [],
};

export default Popup;
